import type { FC, ReactNode } from 'react'
import type { Crumb } from '@/types'

import Link from 'next/link'
import { ChevronRight } from 'lucide-react'

interface BreadcrumbsProps {
    items: Crumb[]
    tone?: 'dark' | 'light'
}

const Breadcrumbs: FC<BreadcrumbsProps> = ({ items = [], tone = 'dark' }): ReactNode => {
    const muted = tone === 'dark' ? 'text-muted-foreground' : 'text-white/80'
    const link = tone === 'dark' ? 'text-primary' : 'text-white'

    return (
        <nav aria-label='Breadcrumb'>
            <ol className={`flex flex-wrap items-center gap-x-1.5 gap-y-1 text-base ${muted}`}>
                {items.map((item, index) => (
                    <li key={`${item.label}-${index}`} className='flex items-center gap-1.5'>
                        {index > 0 && <ChevronRight className='size-4' aria-hidden='true' />}

                        {item.href && index < items.length - 1
                            ? (
                                <Link href={item.href} className={`font-semibold underline-offset-4 hover:underline ${link}`}>
                                    {item.label}
                                </Link>
                            )
                            : <span aria-current='page'>{item.label}</span>}
                    </li>
                ))}
            </ol>
        </nav>
    )
}

export default Breadcrumbs
